import { screenSmMin } from '@spotify-internal/encore-foundation';
import { cssSpacing } from "../../styles/index.mjs";
import { Type } from "../Type/index.mjs";
import styled from "../../styled-components.mjs";
export var Subtitle = styled(Type).attrs({
  semanticColor: 'textSubdued',
  variant: 'ballad'
}).withConfig({
  displayName: "Subtitle",
  componentId: "sc-phhz2w-0"
})(["display:block;margin-block-start:", ";@media (min-width:", "){text-align:center;}"], cssSpacing('tighter-2', '8px'), screenSmMin);